import React from 'react'

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calenderIcon from '../../../assets/images/icons/calendar.svg';
import arrowDownIcon from '../../../assets/images/icons/arrow-down.svg';

import OTPValidationModal from '../../../modals/OTPValidationModal'

export default function GSTInfo() {
    return (
        <div>
            <h3>Enter GST Info</h3>
            <form>
                <div className="dashboard-form-row d-flex">
                    <div className="col-md-6">
                        <div className="form-group">
                            <input type="text" className="form-control" placeholder="GSTIN Number" />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <span className="form-control-icon"><img src={arrowDownIcon}></img></span>
                            <select className="form-select form-control">
                                <option>GST Registration State</option>
                                <option>Tamilnadu</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="dashboard-form-row d-flex">
                    <div className="col-md-6">
                        <div className="form-group">
                        <span className="form-control-icon"><img src={arrowDownIcon}></img></span>
                            <select className="form-select form-control">
                                <option>Data Consent</option>
                                <option>Yes</option>
                                <option>No</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <input type="text" className="form-control" placeholder="GSTIN User Name" />
                        </div>
                    </div>
                </div>
                <div className="col-md-12 form-add-button">
                    <button type="button" className="btn btn-primary" data-bs-toggle="modal"
                        data-bs-target="#otpValidationModal">Add</button>
                </div>
            </form>
            <OTPValidationModal />
        </div>
    )
}
